export default {"brand.name":[{"type":0,"value":"ScopeFold"}]};